var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1LeftArrowD(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 19.77L29.6 38 48 56.23 45.2 59 24 38l21.2-21 2.8 2.77z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Left_arrow_D.bd889d2d.svg";
export { SvgJ1LeftArrowD as ReactComponent };